import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { FiAlertCircle, FiX } from 'react-icons/fi';

const WarningModal = ({ isOpen, onClose, title, message }) => {
  const { isDarkMode } = useTheme();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div 
        className={`w-full max-w-sm rounded-2xl shadow-2xl relative overflow-hidden transform transition-all 
          ${isDarkMode ? 'bg-gray-900 border border-gray-700' : 'bg-white'}`}
      >
        <div className={`p-6 border-b flex justify-between items-center ${isDarkMode ? 'border-gray-800' : 'border-gray-100'}`}>
          <div className="flex items-center gap-2">
            <FiAlertCircle className="text-amber-500 w-6 h-6" />
            <h3 className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
              {title || 'Aviso'}
            </h3>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-red-500 transition-colors">
            <FiX size={20} />
          </button>
        </div>
        
        <div className="p-6">
          <p className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
            {message}
          </p>
        </div>
        
        <div className={`p-4 border-t flex justify-end ${isDarkMode ? 'border-gray-800 bg-gray-900' : 'border-gray-100 bg-gray-50'}`}>
          <button 
            onClick={onClose} 
            className="px-6 py-2 bg-amber-500 hover:bg-amber-600 text-white rounded-xl font-bold shadow-sm transition-colors"
          >
            Entendi
          </button>
        </div>
      </div>
    </div>
  );
};

export default WarningModal;
